import { LoadingButton } from "@mui/lab";
import { Alert, Stack } from "@mui/material";
import { FormProvider } from "src/components/hook-form";
import useLocales from "src/hooks/useLocales";

import { useChangePasswordForm } from "../hooks/useChangePasswordForm";
import PasswordInput from "./PasswordInput";

// ----------------------------------------------------------------------

export default function ChangePasswordForm() {
	const { translate } = useLocales();

	const { methods, isLoading, onSubmit, errorMessage } = useChangePasswordForm();

	return (
		<FormProvider methods={methods} onSubmit={onSubmit}>
			<Stack spacing={3}>
				{errorMessage !== "" && <Alert severity='error'>{errorMessage}</Alert>}
				<PasswordInput title='Contraseña actual' name='password' />
				<PasswordInput title='Nueva contraseña' name='newPassword' />
				<PasswordInput title='Confirma nueva contraseña' name='confirmNewPassword' />
			</Stack>
			<LoadingButton
				fullWidth
				loading={isLoading}
				size='large'
				type='submit'
				variant='contained'
				sx={{ mt: 4 }}
			>
				{translate("Cambiar y entrar")}
			</LoadingButton>
		</FormProvider>
	);
}
